import request from '@/utils/request'
import URL from './urlTranslator'

export function getOfficeDeptTree() {
  return request({
    url: URL.sys.officeDeptTree,
    method: 'get'
  })
}

export function getOfficeList(params) {
  return request({
    url: `${URL.sys.office}`,
    method: 'get',
    params
  })
}
export function getOfficeByUuid(uuid) {
  const params = { uuid }
  return request({
    url: `${URL.sys.officeDetail}`,
    method: 'get',
    params
  })
}
export function getOfficeById(id) {
  const params = { id }
  return request({
    url: `${URL.sys.officeDetailById}`,
    method: 'get',
    params
  })
}

export function getOfficeListByTenantId(params) {
  return request({
    url: URL.sys.officeList,
    method: 'get',
    params
  })
}

export function loadTaxControlPanelFunc(officeUuid) {
  return request({
    url: URL.sys.loadTaxControlPanelUrl,
    method: 'get',
    params: { officeUuid }
  })
}

export function queryTaxPanelNoStr(officeUuid) {
  return request({
    url: URL.sys.queryTaxPanelNoStrUrl,
    method: 'get',
    params: { officeUuid }
  })
}

export function delOfficeByUuid(uuid) {
  const params = { uuid }
  return request({
    url: `${URL.sys.office}`,
    method: 'delete',
    params
  })
}

export function saveOffice(data) {
  return request({
    url: URL.sys.office,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function copyOffice(data) {
  return request({
    url: URL.sys.copyOffice,
    method: 'post',
    data
  })
}

export function copyRole(data) {
  return request({
    url: URL.sys.copyRoleUrl,
    method: 'post',
    data
  })
}
export function updateDefaultRmbAccount(params) {
  return request({
    url: URL.sys.defaultRmbAccount,
    method: 'put',
    params
  })
}

export function updateDefaultUsdAccount(params) {
  return request({
    url: URL.sys.defaultUsdAccount,
    method: 'put',
    params
  })
}

export function queryParentOffice(requestBody) {
  return request({
    url: URL.sys.parentOfficeList,
    method: 'post',
    data: requestBody
  })
}
export function roleUserDataFunc(data) {
  return request({
    url: URL.sys.roleUserDataUrl,
    method: 'post',
    data
  })
}

export function getAllOffice() {
  return request({
    url: URL.sys.getAllOffice,
    method: 'get'
  })
}

export function getUserByTreeOffice() {
  return request({
    url: URL.sys.getUserByTreeOffice,
    method: 'get'
  })
}

// export function allOffice() {
//   return request({
//     url: URL.sys.allOffice,
//     method: 'get'
//   })
// }

export function getInvoicerList(uuid) {
  return request({
    url: URL.sys.queryInvoicerUserList,
    method: 'get',
    params: { uuid }
  })
}

export function modifyMawbRemindMargin(form) {
  const data = new FormData()
  for (const key in form) {
    data.append(key, form[key])
  }
  return request({
    url: URL.sys.modifyMawbRemindMargin,
    method: 'post',
    data: data
  })
}
